import React, { Component } from 'react';
import {HorizontalBar, Chart} from 'react-chartjs-2';
var colors = ['#f68e56', 'rgb(246, 142, 86)', 'rgb(183, 206, 99)', 'rgb(6, 190, 189)', 'rgb(60, 67, 80)', '#002f87', '#9da1a7'];
const data1 = {
        labels: [
          'Air Force', 'Arizona', 'Arizona State', 'Army', 'Ball State', 'BYU', 'California', 'Cal Poly Pomona', 'Cal State Fullerton', 'Cal State L.A.', 'Cal State Northridge', 'Chicago', 'Colorado', 'Colorado State', 'Denver', 'Florida State', 'Fresno State', 'Georgia', 'Georgia Southern', 'Georgia Tech', 'Gustavus Adolphus', 'Houston Baptist', 'Illinois', 'Illinois Chicago', 'Illinois State', 'Indiana', 'Indiana State', 'Iowa', 'Iowa State', 'Kent State', 'LSU', 'Massachusetts', 'Michigan', 'Michigan State', 'Minnesota', 'Minn. State Mankato', 'Navy', 'Nebraska', 'New Mexico', 'North Carolina', 'Northern Illinois', 'Occidental', 'Ohio State', 'Oklahoma', 'Oregon', 'Penn State', 'Pittsburgh', 'Sacramento State', 'San Diego State', 'San Jose State', 'Southern California', 'Southern Conn. State', 'Southern Illinois', 'Springfield', 'Stanford', 'Syracuse', 'Temple', 'UCLA', 'Washington', 'Washington State', 'West Virginia', 'Western Illinois', 'William & Mary', 'Wisconsin', 'Yale'
        ],
        datasets: [{
            label: "NCAA Championship Appearances",
            backgroundColor: [colors[2],
                            colors[1],
                            colors[2],
                            colors[3],
                            colors[1],
                            colors[1],
                            colors[6],
                            colors[1],
                            colors[1],
                            colors[1],
                            colors[1],
                            colors[2],
                            colors[1],
                            colors[1],
                            colors[1],
                            colors[2],
                            colors[1],
                            colors[1],
                            colors[1],
                            colors[1],
                            colors[1],
                            colors[1],
                            colors[5],
                            colors[1],
                            colors[1],
                            colors[1],
                            colors[1],
                            colors[6],
                            colors[2],
                            colors[1],
                            colors[1],
                            colors[1],
                            colors[5],
                            colors[2],
                            colors[6],
                            colors[1],
                            colors[2],
                            colors[5],
                            colors[1],
                            colors[1],
                            colors[1],
                            colors[1],
                            colors[6],
                            colors[5],
                            colors[1],
                            colors[6],
                            colors[1],
                            colors[1],
                            colors[1],
                            colors[1],
                            colors[2],
                            colors[1],
                            colors[2],
                            colors[1],
                            colors[4],
                            colors[2],
                            colors[3],
                            colors[3],
                            colors[1],
                            colors[1],
                            colors[1],
                            colors[1],
                            colors[1],
                            colors[1],
                            colors[1]
                            ],
            borderColor: [colors[2],
                            colors[1],
                            colors[2],
                            colors[3],
                            colors[1],
                            colors[1],
                            colors[6],
                            colors[1],
                            colors[1],
                            colors[1],
                            colors[1],
                            colors[2],
                            colors[1],
                            colors[1],
                            colors[1],
                            colors[2],
                            colors[1],
                            colors[1],
                            colors[1],
                            colors[1],
                            colors[1],
                            colors[1],
                            colors[5],
                            colors[1],
                            colors[1],
                            colors[1],
                            colors[1],
                            colors[6],
                            colors[2],
                            colors[1],
                            colors[1],
                            colors[1],
                            colors[5],
                            colors[2],
                            colors[6],
                            colors[1],
                            colors[2],
                            colors[5],
                            colors[1],
                            colors[1],
                            colors[1],
                            colors[1],
                            colors[6],
                            colors[5],
                            colors[1],
                            colors[6],
                            colors[1],
                            colors[1],
                            colors[1],
                            colors[1],
                            colors[2],
                            colors[1],
                            colors[2],
                            colors[1],
                            colors[4],
                            colors[2],
                            colors[3],
                            colors[3],
                            colors[1],
                            colors[1],
                            colors[1],
                            colors[1],
                            colors[1],
                            colors[1],
                            colors[1]
                            ],
            data: [15, 4, 15, 23, 1, 4, 50, 3, 5, 8, 1, 11, 7, 4, 3, 12, 2, 1, 1, 2, 1, 4, 49, 5, 3, 7, 5, 52, 16, 3, 8, 5, 43, 19, 51, 1, 19, 48, 9, 1, 2, 1, 51, 41, 5, 67, 8, 2, 1, 4, 17, 4, 19, 6, 38, 11, 28, 26, 8, 2, 1, 3, 7, 2, 2],
            fill: false,
        }]
    };
    const data2 = {
            labels: [
              'Penn State', 'Iowa', 'Minnesota', 'Ohio State', 'California', 'Illinois', 'Nebraska', 'Michigan', 'Oklahoma', 'Stanford', 'Temple', 'UCLA', 'Army', 'Michigan State', 'Navy', 'Southern Illinois', 'Southern California', 'Iowa State', 'Air Force', 'Arizona State', 'Florida State', 'Chicago', 'Syracuse', 'New Mexico', 'Cal State L.A.', 'LSU', 'Pittsburgh', 'Washington', 'Colorado', 'Indiana', 'William & Mary', 'Springfield', 'Cal State Fullerton', 'Illinois Chicago', 'Indiana State', 'Massachusetts', 'Oregon', 'Arizona', 'BYU', 'Colorado State', 'Houston Baptist', 'San Jose State', 'Southern Conn. State', 'Cal Poly Pomona', 'Denver', 'Illinois State', 'Kent State', 'Western Illinois', 'Fresno State', 'Georgia Tech', 'Northern Illinois', 'Sacramento State', 'Washington State', 'Wisconsin', 'Yale', 'Ball State', 'Cal State Northridge', 'Georgia', 'Georgia Southern', 'Gustavus Adolphus', 'Minn. State Mankato', 'North Carolina', 'Occidental', 'San Diego State', 'West Virginia'
            ],
            datasets: [{
                label: "NCAA Championship Appearances",
                backgroundColor: [colors[6],
                                colors[6],
                                colors[6],
                                colors[6],
                                colors[6],
                                colors[5],
                                colors[5],
                                colors[5],
                                colors[5],
                                colors[4],
                                colors[3],
                                colors[3],
                                colors[3],
                                colors[2],
                                colors[2],
                                colors[2],
                                colors[2],
                                colors[2],
                                colors[2],
                                colors[2],
                                colors[2],
                                colors[2],
                                colors[2],
                                colors[1],
                                colors[1],
                                colors[1],
                                colors[1],
                                colors[1],
                                colors[1],
                                colors[1],
                                colors[1],
                                colors[1],
                                colors[1],
                                colors[1],
                                colors[1],
                                colors[1],
                                colors[1],
                                colors[1],
                                colors[1],
                                colors[1],
                                colors[1],
                                colors[1],
                                colors[1],
                                colors[1],
                                colors[1],
                                colors[1],
                                colors[1],
                                colors[1],
                                colors[1],
                                colors[1],
                                colors[1],
                                colors[1],
                                colors[1],
                                colors[1],
                                colors[1],
                                colors[1],
                                colors[1],
                                colors[1],
                                colors[1],
                                colors[1],
                                colors[1],
                                colors[1],
                                colors[1],
                                colors[1],
                                colors[1]
                                ],
                borderColor: [colors[6],
                                colors[6],
                                colors[6],
                                colors[6],
                                colors[6],
                                colors[5],
                                colors[5],
                                colors[5],
                                colors[4],
                                colors[3],
                                colors[3],
                                colors[3],
                                colors[2],
                                colors[2],
                                colors[2],
                                colors[2],
                                colors[2],
                                colors[2],
                                colors[2],
                                colors[2],
                                colors[2],
                                colors[2],
                                colors[1],
                                colors[1],
                                colors[1],
                                colors[1],
                                colors[1],
                                colors[1],
                                colors[1],
                                colors[1],
                                colors[1],
                                colors[1],
                                colors[1],
                                colors[1],
                                colors[1],
                                colors[1],
                                colors[1],
                                colors[1],
                                colors[1],
                                colors[1],
                                colors[1],
                                colors[1],
                                colors[1],
                                colors[1],
                                colors[1],
                                colors[1],
                                colors[1],
                                colors[1],
                                colors[1],
                                colors[1],
                                colors[1],
                                colors[1],
                                colors[1],
                                colors[1],
                                colors[1],
                                colors[1],
                                colors[1],
                                colors[1],
                                colors[1],
                                colors[1],
                                colors[1],
                                colors[1],
                                colors[1],
                                colors[1],
                                colors[1]
                                ],
                data: [67, 52, 51, 51, 50, 49, 48, 43, 41, 38, 28, 26, 23, 19, 19, 19, 17, 16, 15, 15, 12, 11, 11, 9, 8, 8, 8, 8, 7, 7, 7, 6, 5, 5, 5, 5, 5, 4, 4, 4, 4, 4, 4, 3, 3, 3, 3, 3, 2, 2, 2, 2, 2, 2, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
                fill: false,
            }]
        };

class NCAAChamps extends Component {
  constructor(props) {
      super(props);
      this.state = {
        data: data1,
        data2: data2
      };
      this.handleClick = this.handleClick.bind(this);
  }
  componentDidMount() {
    Chart.pluginService.register({
      afterDatasetsDraw: () => {
        if(this.refs.chart !== undefined){
          let ctx = this.refs.chart.chart_instance.chart.ctx;
          ctx.font = "14px Verdana";
          ctx.fillStyle = "#ffffff";
          ctx.textAlign = "center";
          ctx.textBaseline = "bottom";
          this.refs.chart.chart_instance.chart.config.data.datasets.forEach(function (dataset) {
            const dataArray = dataset.data;
            var keys = Object.keys(dataset._meta);
            keys.sort(function(a, b){return b-a});
            var indexNum = keys[0];
            if(dataset._meta[indexNum] !== undefined){
              dataset._meta[indexNum].data.forEach(function (bar, index) {
                  ctx.fillText(dataArray[index], bar._view.x-10, bar._view.y+7);
              });
            }
          })
        }
      }
    });
  }
  handleClick() {
    if(this.state.data === data1){
      this.setState({
        data: data2
      });
    } else {
      this.setState({
        data: data1
      });
    }
  }

  render() {
    var dark = document.body.classList.contains('dark-theme');
    return (
      <div className="row expanded">
      <div className="small-12 columns chart-containerNat-wrap">
      <div className="chart-containerNat">
        <div className="teamsbox">
          <div className="button-container">
            <button id="avg" className={"button medium"} onClick={this.handleClick}>Toggle Order</button>
          </div>
        </div>
        <HorizontalBar ref="chart" data={this.state.data}
          redraw={true}
          width={100}
          height={100}
          options={{
            maintainAspectRatio: false,
            responsive: true,
            title:{
              display: true,
              text: 'NCAA Championship Appearances',
              fontColor: dark ? "#DDD" : 'rgba(20,20,20,0.25)'
            },
            scales: {
              xAxes: [{
                  ticks: {
                    	beginAtZero:true,
                      fontColor: dark ? "#aaa" : 'rgba(20,20,20,0.25)',
                	},
                  gridLines: {
                    color: dark ? 'rgba(100,100,100,0.25)' : 'rgba(20,20,20,0.25)',
                  }
            	}],
            	yAxes: [{
                  ticks: {
                    	beginAtZero:true,
                      autoSkip:false,
                      fontColor: dark ? "#aaa" : 'rgba(20,20,20,0.25)',
                	},
                  gridLines: {
                    color: dark ? 'rgba(100,100,100,0.25)' : 'rgba(20,20,20,0.25)',
                  }
            	}]
          	},
            legend: {
              display: false
            }
          }}
        />
      </div></div></div>
    );
  }
}

export default NCAAChamps;



// WEBPACK FOOTER //
// ./src/components/NationalTeams.js